import { defineMessages } from 'react-intl';

export const labels = defineMessages({
  paymentDateLabel: {
    defaultMessage: 'Payment Date',
    description: 'Payment Date label.'
  },
  checkLabel: {
    defaultMessage: 'Check',
    description: 'Singular check.'
  },
  checksLabel: {
    defaultMessage: 'Checks',
    description: 'Plural check.'
  },
  printCheckFailedUnknown: {
    defaultMessage:
      'The following payments failed to print and were not assigned a check number. They will return to the list of checks to be printed.',
    description: 'Print failure dialog comment.'
  },
  printCheckFailedLabel: {
    defaultMessage: 'Failed to Print',
    description: 'Print failure dialog label.'
  },
  printCheckDialogHeaderTitle: {
    defaultMessage: 'Failed To Print Report',
    description: 'Print failure title in export to pdf page.'
  }
});
